export default {"src":"/_next/static/media/instagram.b6cef02d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};